import { useLocalStorage } from '~/hooks/useLocalStorage/useLocalStorage.client'
import { useMediaQuery } from '~/hooks/useMediaQuery/useMediaQuery.client'

interface HtmlProps {
    children: React.ReactNode
}

export const Html = (props: HtmlProps) => {
    const { children } = props
    const [colorScheme] = useLocalStorage('colorScheme')
    const prefersDark = useMediaQuery('(prefers-color-scheme: dark)')

    if (colorScheme === 'dark' || (!colorScheme && prefersDark)) {
        return (
            <html lang="en" className="dark">
                {children}
            </html>
        )
    }

    return <html lang="en">{children}</html>
}
